import { mockComponent } from 'bloko/common/setupMockComponents';

export { default as TreeSelectorDummy } from 'bloko/blocks/treeSelector/Dummy';
export default mockComponent('TreeSelector');
